export enum RoleEnum {
  Admin = 'Admin',
  Employee = 'Employee',
  Provider = 'Provider',
}
